import { faEye, faEyeSlash } from "@fortawesome/fontawesome-free-solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IoIosArrowDown } from "react-icons/io";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setEditDriver,
  setEditDriverValue,
  setSearchDriver,
} from "../redux/driver/driver-slice";
import CountryDropdown from "react-select-country-list";
import { Countrycodes } from "../utils/countryCodes";
import CountryList from "country-list-with-dial-code-and-flag";
import { Form } from "react-router-dom";

const checkEmail = (inputEmail) => {
  const check = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(
    inputEmail
  );

  return check;
};

const Modal = ({
  heading,
  label,
  cancelOnClick,
  submitOnClick,
  driverNameInput,
  carPlateInput,
  carLicenseInput,
  contactNumberInput,
  countryCodeInput,
  setCountryCodeChange,
  setEditCountryCodeChange,
  driverEmailInput,
  driverPasswordInput,
  isDriverCreate,
  driverPassword,
  driverName,
  driverEmail,
  driverCountryCode,
  driverContactNumber,
  driverCarPlateNumber,
  driverCarLicenseNo,
  isDriverModalEdit,
}) => {
  const { editDriver } = useSelector((state) => state.driver);
  const [searchCountryCode, setsearchCountryCode] = useState("");
  const [selectedCountry1, setSelectedCountry1] = useState(false);
  const [selectedCountry2, setSelectedCountry2] = useState(false);
  const [isVisible, setisVisible] = useState();
  const dispatch = useDispatch();
  const emptyField =
    driverName?.trim() === "" ||
    driverCarPlateNumber?.trim() === "" ||
    driverCarLicenseNo?.trim() === "" ||
    driverEmail?.trim() === "" ||
    driverCountryCode?.trim() === "" ||
    driverContactNumber?.trim() === "" ||
    driverPassword?.trim() === "";

  const [formValidation, setformValidation] = useState({
    driverNameError: "",
    countryCodeError: "",
    contactNumberError: "",
    passwordError: false,
    emailError: "",
  });

  // const myCountryCodesObject = CountryList.customList("countryCode", "{countryNameEn}: +{countryCallingCode}");

  // const [driverEdit, setDriverEdit] = useState({
  //   _id:editDriver?._id,
  //   name: editDriver?.name,
  //   countryCode: editDriver?.countryCode,
  //   contactNumber: editDriver?.contactNumber,
  //   password: editDriver?.password,
  //   email: editDriver?.email,
  //   carPlateNo: editDriver?.carPlateNo,
  //   carLicenseNo: editDriver?.carLicenseNo,
  // });

  return (
    <div className="animate__animated animate__fadeInDown fixed inset-0 z-50 flex items-center justify-center overflow-x-hidden overflow-y-auto outline-none focus:outline-none">
      <div className="relative w-full mx-10 lg:w-[604px] max-w-3xl mt-16 mb-10">
        {/*content*/}
        <div className="cardBorder1 borderFN">
          <div
            id="grad"
            className="relative flex flex-col w-full rounded-lg shadow-lg outline-none focus:outline-none"
          >
            {/*header*/}
            <div
              className="flex items-start justify-between bg-gradient-to-r from-[#0c0c0c] via-[#444444] to-[#0c0c0c] px-6 py-3 w-full text-base font-semibold border-b border-solid rounded-t-lg border-slate-900"
              onClick={() => {
                setSelectedCountry2(false);
                setSelectedCountry1(false);
              }}
            >
              <h3 className="text-lg font-medium text-white/90">{heading}</h3>
              <button
                className="float-right p-1 ml-auto text-3xl font-semibold leading-none text-black"
                onClick={cancelOnClick}
              >
                <span className="block w-6 h-4 -mt-3 mr-0 text-4xl text-gray-300">
                  ×
                </span>
              </button>
            </div>
            {/* body */}
            <div>
              {isDriverCreate && (
                <div className="overflow-y-auto sm:overflow-y-visible h-[52vh] sm:h-auto relative flex-auto p-6 space-y-3 z-0">
                  <div className="sm:flex sm:space-x-5 space-y-3 sm:space-y-0">
                    <div className="grow">
                      <ModalInputField
                        required
                        labelName="Driver Name "
                        type="text"
                        placeholder="Enter User Name"
                        inputvalue={driverName}
                        onChange={(e) => {
                          setformValidation({
                            ...formValidation,
                            driverNameError: "",
                          });
                          driverNameInput(e);
                        }}
                        onClick={() => {
                          setSelectedCountry1(false);
                        }}
                        onBlur={() => {
                          if (driverName === "") {
                            console.log("driver errpr");
                            setformValidation({
                              ...formValidation,
                              driverNameError: "Driver name is required",
                            });
                          } else if (driverName?.trim()?.length < 2) {
                            setformValidation({
                              ...formValidation,
                              driverNameError:
                                "Name should be more than 1 character",
                            });
                          } else {
                            setformValidation({
                              ...formValidation,
                              driverNameError: "",
                            });
                          }
                        }}
                      />

                      <p className="text-red-500 text-sm pt-1 ">
                        {formValidation.driverNameError !== "" &&
                          formValidation.driverNameError}
                      </p>
                    </div>
                    <div className="grow">
                      <ModalInputField
                        labelName="Car Plate Number"
                        type="text"
                        placeholder="Enter car plate number"
                        inputvalue={driverCarPlateNumber}
                        onChange={carPlateInput}
                        onClick={() => {
                          setSelectedCountry1(false);
                        }}
                      />
                    </div>
                  </div>
                  <div className="sm:flex sm:space-x-5 space-y-3 sm:space-y-0">
                    <div className="grow">
                      <ModalInputField
                        labelName="Car License Number"
                        type="text"
                        placeholder="Enter car license number"
                        inputvalue={driverCarLicenseNo}
                        onChange={carLicenseInput}
                        onClick={() => {
                          setSelectedCountry1(false);
                        }}
                      />
                    </div>
                    <div className="grow">
                      <ModalInputField
                        labelName="Driver Email"
                        type="email"
                        placeholder="Enter driver email"
                        inputvalue={driverEmail}
                        onChange={(e) => {
                          setformValidation({
                            ...formValidation,
                            emailError: "",
                          });
                          driverEmailInput(e);
                        }}
                        onClick={() => {
                          setSelectedCountry1(false);
                        }}
                        onBlur={() => {
                          const check = checkEmail(driverEmail);
                          if (check === false) {
                            setformValidation({
                              ...formValidation,
                              emailError: "Enter valid email",
                            });
                          }
                        }}
                      />
                      <p className="text-red-500 text-sm pt-1 ">
                        {formValidation.emailError !== "" &&
                          formValidation.emailError}
                      </p>
                    </div>
                  </div>
                  <div className="sm:flex sm:space-x-5 space-y-3 sm:space-y-0">
                    <div className="grow relative">
                      <div>
                        <ModalInputField
                          required
                          labelName="Country Code "
                          type="text"
                          placeholder="Enter country code"
                          inputvalue={driverCountryCode}
                          onChange={(e) => {
                            setSelectedCountry1(true);
                            countryCodeInput(e);
                          }}
                          onBlur={() => {
                            if (driverCountryCode === "") {
                              console.log("driver error");
                              setformValidation({
                                ...formValidation,
                                countryCodeError: "Country is required",
                              });
                            } else {
                              setformValidation({
                                ...formValidation,
                                countryCodeError: "",
                              });
                            }
                          }}
                        />
                        <IoIosArrowDown
                          className="text-white absolute top-9 right-3 w-6 h-6 cursor-pointer"
                          onClick={() => {
                            console.log("CountryList", selectedCountry1);
                            setSelectedCountry1(!selectedCountry1);
                          }}
                        />
                        <p className="text-red-500 text-sm pt-1 ">
                          {formValidation.countryCodeError !== "" &&
                            formValidation.countryCodeError}
                        </p>
                      </div>
                      <div className="absolute top-[6.6rem]">
                        {selectedCountry1 && (
                          <div className="bg-gradient-to-br from-[#282828] to-black translate-y-64 absolute -left-1 bottom-14 w-[16.7rem] h-60 overflow-y-auto mx-1 scrollbar rounded-lg shadow-2xl text-white/90 border-2 border-white/30">
                            {Countrycodes?.map((country) => {
                              console.log("single country", country);

                              if (
                                country.name
                                  .toLowerCase()
                                  .includes(driverCountryCode?.toLowerCase())
                              ) {
                                return (
                                  <div
                                    key={country.code}
                                    onClick={() => {
                                      setCountryCodeChange(country);
                                      setSelectedCountry1(false);
                                    }}
                                    className="flex space-x-3 px-3 cursor-pointer text-[15px] py-2 hover:bg-white/20 rounded-md mx-2 my-2 hover:text-white/70"
                                  >
                                    <div>{country.name}</div>
                                    <div>{country.dial_code}</div>
                                  </div>
                                );
                              }
                            })}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="grow">
                      <ModalInputField
                        required
                        labelName="Contact Number "
                        type="text"
                        placeholder="Enter Contact Number"
                        inputvalue={driverContactNumber}
                        onChange={(e) => {
                          setformValidation({
                            ...formValidation,
                            contactNumberError: "",
                          });
                          contactNumberInput(e);
                        }}
                        onClick={() => {
                          setSelectedCountry1(false);
                        }}
                        onBlur={() => {
                          if (driverContactNumber === "") {
                            setformValidation({
                              ...formValidation,
                              contactNumberError: "Driver Contact is required",
                            });
                          } else if (!/^\d+$/.test(driverContactNumber)) {
                            setformValidation({
                              ...formValidation,
                              contactNumberError:
                                "Contact number must be number",
                            });
                          } else if (driverContactNumber?.trim()?.length < 6) {
                            setformValidation({
                              ...formValidation,
                              contactNumberError:
                                "Should be more than 5 character",
                            });
                          } else {
                            setformValidation({
                              ...formValidation,
                              contactNumberError: "",
                            });
                          }
                        }}
                      />
                      <p className="text-red-500 text-sm pt-1 ">
                        {formValidation.contactNumberError !== "" &&
                          formValidation.contactNumberError}
                      </p>
                    </div>
                  </div>
                  <div className="relative ">
                    <div className="space-y-2">
                      <ModalInputField
                        required
                        labelName="Password "
                        type={`${isVisible ? "text" : "password"}`}
                        inputvalue={driverPassword}
                        placeholder="Set password for driver"
                        onChange={(e) => {
                          driverPasswordInput(e);
                        }}
                        onClick={() => {
                          setSelectedCountry1(false);
                        }}
                        onBlur={(e) => {
                          if (!/[a-z]/.test(driverPassword)) {
                            setformValidation({
                              ...formValidation,
                              passwordError: true,
                            });
                          } else if (!/[A-Z]/.test(driverPassword)) {
                            setformValidation({
                              ...formValidation,
                              passwordError: true,
                            });
                          } else if (!/[1-9]/.test(driverPassword)) {
                            setformValidation({
                              ...formValidation,
                              passwordError: true,
                            });
                          } else if (
                            !/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(
                              driverPassword
                            )
                          ) {
                            setformValidation({
                              ...formValidation,
                              passwordError: true,
                            });
                          } else {
                            setformValidation({
                              ...formValidation,
                              passwordError: false,
                            });
                          }

                          driverPasswordInput(e);
                        }}
                      />
                      {formValidation.passwordError && (
                        <div className={`text-sm text-gray-400 `}>
                          <p>
                            Password must be at least 8 characters
                            <span className="text-red-500"> *</span>
                          </p>
                          <div
                            className={`grid grid-cols-1 sm:grid-cols-2 p-2 `}
                          >
                            <div className="flex flex-row gap-2">
                              <div className="flex justify-center items-center">
                                {/[a-z]/.test(driverPassword) ? (
                                  <Tick />
                                ) : (
                                  <div className="size-[10px] bg-gray-400 rounded-full" />
                                )}
                              </div>
                              One lowercase character
                            </div>
                            <div className="flex flex-row gap-2">
                              <div className="flex justify-center items-center">
                                {/[A-Z]/.test(driverPassword) ? (
                                  <Tick />
                                ) : (
                                  <div className="size-[10px] bg-gray-400 rounded-full" />
                                )}
                              </div>
                              One uppercase character
                            </div>
                            <div className="flex flex-row gap-2">
                              <div className="flex justify-center items-center">
                                {/[1-9]/.test(driverPassword) ? (
                                  <Tick />
                                ) : (
                                  <div className="size-[10px] bg-gray-400 rounded-full" />
                                )}
                              </div>
                              One digit
                            </div>
                            <div className="flex flex-row gap-2">
                              <div className="flex justify-center items-center">
                                {/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(
                                  driverPassword
                                ) ? (
                                  <Tick />
                                ) : (
                                  <div className="size-[10px] bg-gray-400 rounded-full" />
                                )}
                              </div>
                              One special symbol
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="text-white absolute right-3 top-9">
                      <div
                        className="cursor-pointer text-slate-500"
                        onClick={() => {
                          setisVisible(!isVisible);
                        }}
                      >
                        {isVisible ? (
                          <FontAwesomeIcon icon={faEye} />
                        ) : (
                          <FontAwesomeIcon icon={faEyeSlash} />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div>
              {isDriverModalEdit && (
                <>
                  <div className="overflow-y-auto sm:overflow-y-visible h-[52vh] sm:h-auto relative flex-auto p-6 space-y-3">
                    <div className="sm:flex sm:space-x-5 space-y-3 sm:space-y-0">
                      <div className="grow">
                        <ModalInputField
                          labelName="Driver Name"
                          type="text"
                          placeholder="Enter User Name"
                          inputvalue={editDriver?.name}
                          onChange={(e) => {
                            dispatch(
                              setEditDriverValue({
                                key: "name",
                                value: e.target.value,
                              })
                            );
                          }}
                          onClick={() => {
                            setSelectedCountry2(false);
                          }}
                        />
                      </div>
                      <div className="grow">
                        <ModalInputField
                          labelName="Car Plate Number"
                          type="text"
                          placeholder="Enter car plate number"
                          inputvalue={editDriver?.carPlateNo}
                          onChange={(e) => {
                            dispatch(
                              setEditDriverValue({
                                key: "carPlateNo",
                                value: e.target.value,
                              })
                            );
                          }}
                          onClick={() => {
                            setSelectedCountry2(false);
                          }}
                        />
                      </div>
                    </div>
                    <div className="sm:flex sm:space-x-5 space-y-3 sm:space-y-0">
                      <div className="grow">
                        <ModalInputField
                          labelName="Car License Number"
                          type="text"
                          placeholder="Enter car license number"
                          inputvalue={editDriver?.carLicenseNo}
                          onChange={(e) => {
                            dispatch(
                              setEditDriverValue({
                                key: "carLicenseNo",
                                value: e.target.value,
                              })
                            );
                          }}
                          onClick={() => {
                            setSelectedCountry2(false);
                          }}
                        />
                      </div>
                      <div className="grow">
                        <ModalInputField
                          labelName="Driver Email"
                          type="email"
                          placeholder="Enter driver email"
                          inputvalue={editDriver?.email}
                          onChange={(e) => {
                            dispatch(
                              setEditDriverValue({
                                key: "email",
                                value: e.target.value,
                              })
                            );
                          }}
                          onClick={() => {
                            setSelectedCountry2(false);
                          }}
                        />
                      </div>
                    </div>
                    <div className="sm:flex sm:space-x-5 space-y-3 sm:space-y-0">
                      <div className="grow relative">
                        <div>
                          <ModalInputField
                            labelName="Country Code"
                            type="text"
                            placeholder="Enter country code"
                            inputvalue={editDriver?.countryCode}
                            // onChange={(e) => {
                            //   dispatch(
                            //     setEditDriverValue({
                            //       key: "countryCode",
                            //       value: e.target.value,
                            //     })
                            //   );
                            // }}
                          />
                          <IoIosArrowDown
                            className="text-white absolute top-9 right-3 w-6 h-6 cursor-pointer"
                            onClick={() => {
                              console.log("CountryList", selectedCountry2);
                              setSelectedCountry2(!selectedCountry2);
                            }}
                          />
                        </div>
                        <div className="absolute top-[3.6rem]">
                          {selectedCountry2 && (
                            <div className="bg-gradient-to-br from-[#282828] to-black translate-y-64 absolute -left-1 bottom-14 w-[16.7rem] h-60 overflow-y-auto mx-1 scrollbar rounded-lg shadow-2xl text-white/90 border-2 border-white/30">
                              {Countrycodes?.map((country) => {
                                console.log("single country", country);
                                return (
                                  <div
                                    key={country.code}
                                    onClick={() => {
                                      dispatch(
                                        setEditDriverValue({
                                          key: "countryCode",
                                          value: country.dial_code,
                                        })
                                      );
                                      setSelectedCountry2(false);
                                    }}
                                    className="flex space-x-3 px-3 cursor-pointer text-[15px] py-2 hover:bg-white/20 rounded-md mx-2 my-2 hover:text-white/70"
                                  >
                                    <div>{country.name}</div>
                                    <div>{country.dial_code}</div>
                                  </div>
                                );
                              })}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="grow">
                        <ModalInputField
                          labelName="Contact Number"
                          type="text"
                          placeholder="Enter Contact Number"
                          inputvalue={editDriver?.contactNumber}
                          onChange={(e) => {
                            dispatch(
                              setEditDriverValue({
                                key: "contactNumber",
                                value: e.target.value,
                              })
                            );
                          }}
                          onClick={() => {
                            setSelectedCountry2(false);
                          }}
                        />
                      </div>
                    </div>
                    {/* <div>
                    <ModalInputField
                      labelName="Password"
                      type="password"
                      value={driverPassword}
                      placeholder="Set password for driver"
                      fontawesomeIcon={faKey}
                      onChange={driverPasswordInput}
                    />
                  </div> */}
                  </div>
                </>
              )}
            </div>

            {/*footer*/}
            <div
              className="flex items-center space-x-6 justify-center pt-2 pb-6 rounded-b border-slate-700"
              onClick={() => {
                setSelectedCountry2(false);
                setSelectedCountry1(false);
              }}
            >
              <button
                className="w-28 sm:w-36 h-12 bg-[#181E29] border-2 border-[#1d2430] text-lg font-medium text-gray-100 hover:bg-[#161a22] rounded-md"
                type="button"
                onClick={cancelOnClick}
              >
                Cancel
              </button>
              <button
                disabled={emptyField}
                className={`w-28 sm:w-36 h-12 bg-[#144EE3] hover:bg-[#0a44d9] border-2 border-[#144EE3] disabled:bg-gray-600 disabled:border-gray-600 text-lg font-medium text-white rounded-md ${
                  emptyField ? "cursor-no-drop" : ""
                }
                `}
                type="button"
                onClick={submitOnClick}
              >
                {label}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;

export const ModalInputField = ({
  labelName,
  type,
  placeholder,
  onChange,
  fontawesomeIcon,
  inputvalue,
  inputvaluetextArea,
  onClick,
  onFocus,
  maxLength,
  required,
  onBlur,
  disabled,
}) => {
  // const [show, setShow] = useState(false);
  // const handleBlur = (inputvalue) => {
  //   if (inputvalue.trim() === "") {
  //     setShow(true);
  //   } else {
  //     setShow(false);
  //   }
  // };

  return (
    <div className="">
      <div className="space-y-1 text-left">
        <div className="flex items-center space-x-2">
          <FontAwesomeIcon
            // icon={fontawesomeIcon}
            className="w-4 h-4 text-gray-500"
          />
          <div className="text-slate-300 text-sm font-medium">
            {labelName}
            <span className={required ? "text-red-500" : "hidden"}>*</span>
          </div>
        </div>
        {type === "textarea" ? (
          <textarea
            required={required}
            className="w-full px-3 py-2 text-base text-gray-700 placeholder-gray-400 border rounded-lg focus:outline-none"
            rows="2"
            placeholder={placeholder}
            onChange={onChange}
            value={inputvaluetextArea}
            onBlur={onBlur}
          />
        ) : (
          <input
            required={required}
            type={type}
            placeholder={placeholder}
            className="w-full border border-white/40 focus:border-blue-600 bg-black text-sm text-neutral-200 focus:outline-none grow px-3 py-3.5 rounded-md"
            onChange={onChange}
            value={inputvalue}
            onClick={onClick}
            onFocus={onFocus}
            maxLength={maxLength}
            onBlur={onBlur}
            disabled={disabled}
          />
        )}
        {/* {type === "email" &&
          inputvalue.length > 0 &&
          !checkEmail(inputvalue) && (
            <p className="text-red-400 text-sm">Not Valid Email</p>
          )}
        {show && required && (
          <p className="text-red-400 text-sm">This Field is required</p>
        )} */}
      </div>
    </div>
  );
};

const Tick = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="10"
      viewBox="0 0 12 12"
      fill="none"
    >
      <circle cx="6" cy="6" r="5.5" fill="#144EE3" stroke="#002EA6" />
      <path
        d="M3 6.09524L4.81818 8L9 4"
        stroke="white"
        stroke-linecap="round"
      />
    </svg>
  );
};
